export const downloadBtns = [
  {
    href: 'https://apps.apple.com/us/app/hudd/id6503947586',
    src: '/new/app-promo/app_store.png',
    alt: 'App Store',
  },
  {
    href: 'https://play.google.com/store/apps/details?id=com.hudd.hudd',
    src: '/new/app-promo/google_play.png',
    alt: 'Google Play',
  },
];

export const decorImg = {
  src: '/new/app-promo/decor.png',
};
